/**
 * Permet de parser une URL de service en ses différents composants
 * @param urlenv
 * @returns
 */
export function parseServiceUrl(urlenv: string): {
    url: string
    username: string
    password: string
} {
    // Détection du schéma (http ou https)
    const scheme = urlenv.startsWith("https") ? "https" : "http"

    // Séparation de la partie authentification et de l'URL
    const [authPart, urlPart] = urlenv.split("@")
    const url = `${scheme}://${urlPart}`

    // Séparation des identifiants username et password
    const authDetails = authPart.split("//")[1]
    const [username, password] = authDetails.split(":")

    return { url, username, password }
}

/**
 * Parse un float sans avoir de NaN en cas d'erreur
 * @param value - Valeur à parser
 * @returns Float ou null si la valeur n'est pas un nombre
 */
export const parseFloatSafety = (value?: number | string | null) => {
    if (value == null) return null

    const float =
        typeof value === "number" && !isNaN(value)
            ? value
            : parseFloat(value as string)
    return !isNaN(float) ? float : null
}

/**
 * Permet de parser une date en objet Date
 * @param date - Date à parser
 * @param format - Format de la date (par défaut: "dd/MM/yyyy")
 * @returns Date parsée
 * @throws Error si le format de date n'est pas reconnu
 */
export function parseDate(date: string, format = "dd/MM/yyyy") {
    if (!date || !["YYYY-MM-DD", "dd/MM/yyyy"].includes(format)) {
        return null
    }

    if (format === "YYYY-MM-DD") {
        const [year, month, day] = date.split("-").map(Number)
        if (!day || !month || !year || day > 31 || month > 12) return null
        return new Date(year, month - 1, day)
    }
    if (format === "dd/MM/yyyy") {
        const [day, month, year] = date.split("/").map(Number)
        if (!day || !month || !year || day > 31 || month > 12) return null
        return new Date(year, month - 1, day)
    }
    return null
}
